import React from "react";
import styled from "styled-components/macro";
import { withRouter } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import {
  CardContent,
  Grid,
  Button as MuiButton,
  Card as MuiCard,
  Divider as MuiDivider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography as MuiTypography,
} from "@material-ui/core";

import { spacing, display } from "@material-ui/system";

import jsPDFInvoiceTemplate, { OutputType } from "jspdf-invoice-template";

import { getClientBankInfo } from "../../services/profileSettingService";

const Card = styled(MuiCard)`
  ${spacing};

  box-shadow: none;
`;

const Divider = styled(MuiDivider)(spacing);

const Shadow = styled.div`
  box-shadow: ${(props) => props.theme.shadows[1]};
`;

const Button = styled(MuiButton)(spacing);

const Typography = styled(MuiTypography)(display);

class InvoiceDetails extends React.Component {
  state = {
    values: null,
    bankName: null,
    bankAccountNumber: null,
  };

  printInvoice = () => {
    let invoiceData = this.state.values;

    invoiceData.contact.otherInfo =
      "Cuenta bancaria: " +
      this.state.bankName +
      " " +
      this.state.bankAccountNumber;
    return jsPDFInvoiceTemplate(invoiceData);
  };

  componentDidMount() {
    const { location } = this.props;
    let localStg = JSON.parse(sessionStorage.getItem("token_store"));

    console.log(location.state);

    getClientBankInfo()
      .then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((element) => {
            this.setState({ bankName: element.bank.name });
            this.setState({ bankAccountNumber: element.bankAccountNumber });
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });

    let valuesInvoice = {
      outputType: OutputType.Save,
      returnJsPDFDocObject: true,
      fileName: location.state.idInvoice,
      orientationLandscape: false,
      logo: {
        src: "/static/img/avatars/logo.png",
        width: 53.33, //aspect ratio = width/height
        height: 26.66,
        margin: {
          top: 0, //negative or positive num, from the current position
          left: 0, //negative or positive num, from the current position
        },
      },
      business: {
        name: "WifiAds",
        address: "Santiago, República Dominicana",
        phone: "809 123 4321",
        email: "info@wifiads.info",
        email_1: "RNC 123456789", //The library dont have rnc field.
        website: "",
      },
      contact: {
        label: "Factura emitida para:",
        name: localStg.name + " " + localStg.lastName,
        address:
          localStg.streetAddress +
          ", " +
          localStg.city +
          ", " +
          localStg.country,
        phone: localStg.mobileNumber,
        email: localStg.email,
        otherInfo: null,
      },
      invoice: {
        label: "Pago # ",
        num: location.state.idInvoice,
        invDate: location.state.payedDate /* + location.state.dateInvoice */,
        invGenDate: location.state.calculatedDate,
        headerBorder: false,
        tableBodyBorder: false,
        header: [
          {
            title: "Detalles",
          },
          {
            title: "",
          },
        ],
        table: [
          ["Cantidad de vistar generadas", location.state.quantity],
          ["Costo generado de publicidad", "$RD " + location.state.cost],
          ["Ganancia bruta", "$RD " + location.state.grossPay],
        ],
        additionalRows: [
          {
            col1: "Total:",
            col2: "RD$ " + location.state.pay.toLocaleString(),
            style: {
              fontSize: 14, //optional, default 12
            },
          },
          {
            col1: "Itbis (%18):",
            col2: "RD$ " + location.state.tax.toLocaleString(),
            style: {
              fontSize: 10, //optional, default 12
            },
          },
          {
            col1: "Retención del sistema:",
            col2: "RD$ " + location.state.retention.toLocaleString(),
            style: {
              fontSize: 10, //optional, default 12
            },
          },
          {
            col1: "SubTotal:",
            col2: "RD$ " + location.state.grossPay.toLocaleString(),
            style: {
              fontSize: 10, //optional, default 12
            },
          },
        ],

        invDescLabel: "",
        invDesc:
          "Este es el recibo de un pago de RD$ " +
          location.state.pay.toLocaleString() +
          " que se le realizó a su cuenta bancaria No." +
          this.state.bankAccountNumber +
          " perteneciente a la instituación financiera " +
          this.state.bankName,
      },
      footer: {
        text: "",
      },
      pageEnable: true,
      pageLabel: "Page ",
    };
    this.setState({ values: valuesInvoice });
  }

  render() {
    const { location } = this.props;
    let localStg = JSON.parse(sessionStorage.getItem("token_store"));
    //console.log(location);

    return (
      <React.Fragment>
        <Helmet title="Invoice Details" />

        <Grid justify="space-between" container spacing={10}>
          <Grid item>
            <Typography variant="h4" gutterBottom display="inline">
              {"Factura No. " + location.state.idInvoice}
            </Typography>
          </Grid>
        </Grid>

        <Divider my={6} />

        <Grid container justify="center">
          <Grid item xs={12} lg={10}>
            <Shadow>
              <Card px={6} pt={0}>
                <CardContent>
                  <Grid container spacing={6}>
                    <Grid justifyContent="space-between" container spacing={5}>
                      <Grid item></Grid>
                      <Grid item>
                        <Typography
                          style={{
                            fontSize: "1.6rem",
                            fontWeight: "bold",
                            marginTop: "1rem",
                          }}
                        >
                          WifiAds
                        </Typography>
                        <Typography variant="body1">
                          Santiago, República Dominicana.
                        </Typography>
                        <Typography variant="body1">8091234321</Typography>
                        <Typography variant="body1">
                          info@wifiads.info
                        </Typography>
                        <Typography variant="body1">RNC: 123456789</Typography>
                        <br />
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="body2" gutterBottom>
                        {"Hola "}
                        <b>{localStg.name + " " + localStg.lastName}</b>,
                        <br />
                        <br />
                        {"Este es el recibo de un pago de "}
                        <b>{"RD$ " + location.state.pay.toLocaleString()}</b>
                        {" que se le realizó a su cuenta bancaria "}
                        <b>{"No." + this.state.bankAccountNumber}</b>
                        {" perteneciente a la instituación financiera "}
                        <b>{this.state.bankName}</b>
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Número de pago: " + location.state.reference}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Fecha de factura: " + location.state.calculatedDate}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Fecha de pago: " + location.state.payedDate}
                      </Typography>
                    </Grid>
                    {/*      <Grid item xs={12} md={6}>
                      <Typography
                        variant="caption"
                        align="right"
                        display="block"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Pagado a
                      </Typography>
                      <Typography variant="body1" align="right">
                        RNC: 123456789
                        <br />
                        WiFiAds.
                        <br />
                        Santiago de los Caballeros
                        <br />
                        Santiago
                        <br />
                        República Dominicana
                        <br />
                        <Link href="mailto:info@wifiads.com">
                          info@wifiads.com
                        </Link>
                      </Typography>
                    </Grid> */}
                  </Grid>
                </CardContent>
              </Card>
              <Card px={6}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Detalles
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Cantidad de vistas generadas
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {location.state.quantity}
                      </TableCell>
                      <TableCell />
                      <TableCell />
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Costo generado de publicidad
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"RD$ " + location.state.cost}
                      </TableCell>
                      <TableCell />
                      <TableCell />
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        Ganancias bruta
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"RD$ " + location.state.grossPay}
                      </TableCell>
                      <TableCell />
                      <TableCell />
                    </TableRow>
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"ITBIS (18%)"}
                      </TableCell>
                      <TableCell align="right">
                        {"RD$ " + location.state.tax.toLocaleString()}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Retención del sistema"}
                      </TableCell>
                      <TableCell align="right">
                        {"RD$ " + location.state.retention.toLocaleString()}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Retenciones totales"}
                      </TableCell>
                      <TableCell align="right">
                        {"RD$ " +
                          (
                            location.state.retention + location.state.tax
                          ).toLocaleString()}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {"Total a pagar"}
                      </TableCell>
                      <TableCell align="right">
                        {"RD$ " + location.state.pay.toLocaleString()}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Card>
              <Card pb={6} px={6}>
                <CardContent style={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    mt={2}
                    onClick={() => {
                      this.printInvoice();
                    }}
                  >
                    Imprimir recibo
                  </Button>
                </CardContent>
              </Card>
            </Shadow>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withRouter(InvoiceDetails);
